import { defineAsyncComponent } from 'vue'
const IslandRenderer = import.meta.server ? defineAsyncComponent(() => import("/usr/src/app/node_modules/.bun/nuxt@4.6.2+6887b9758eaf5934/node_modules/nuxt/dist/app/components/island-renderer").then(r => r.default || r)) : () => null
export default IslandRenderer